<template>
  <div class="container">
    <div style="position: relative;height: 100%">
      <div class="info">
        <div>
          <div class="name ellipse">{{rewardInfo.deliveryName}}</div>
          <div class="tag">{{rewardInfo.deliveryEnounce}}</div>
        </div>
        <img class="headImg" :src="rewardInfo.deliveryAvatar" alt="">
      </div>

      <div class="contact">
        <!--<img src="../assets/images/reward-message.png" alt="" style="width: .25rem; height: .18rem;margin-right: .07rem;">-->
        <!--<span class="message">在线联系</span>-->
        <!--<i class="reward-line"></i>-->
        <a :href="'tel:'+ rewardInfo.deliveryTel" style="display: flex;align-items: center;">
          <img src="../assets/images/reward-tel.png" alt="" style="width: .21rem; height: .21rem;margin-right: .07rem;">
          <span class="tel">电话联系</span>
        </a>
      </div>

      <div style="height: .2rem; background: #F5F5F5;"></div>

      <div class="reward">
        <div class="tit">打赏西游侠</div>
        <div class="des" v-if="!rewardInfo.orderRewardAmount">打赏将全额转给同学，平台不扣取任何费用</div>
        <div class="items-box" v-if="!rewardInfo.orderRewardAmount">
          <div class="reward-items" v-for="(item,index) in rewardInfo.configList" :key="index">
            <img class="avater" :src="item.url" alt="">
            <div class="reward-price">{{item.type? '其他金额' : '¥' + item.amount}}</div>
            <span class="reward-btn" @click="openReward(item)">打赏</span>
          </div>
        </div>
        <div v-if="rewardInfo.orderRewardAmount" class="receive-reward">
          <img src="../assets/images/delivery.png" alt="" style="width: 2.28rem; height: 2.08rem;">
          <div style="color: #2F2F2F;;">
            <div style="font-size: .34rem;font-weight: 700;">已收到打赏<span style="color: red">{{rewardInfo.orderRewardAmount}}元</span>。谢谢您！</div>
            <div style="font-size: .26rem;margin-top: .12rem;">感谢您的认可，我会继续努力！</div>
          </div>
        </div>
        <div class="reward-bottom">
          <div class="reward-number">他收到过{{rewardInfo.deliveryRewardCounts}}次打赏</div>
          <div style="display: flex;align-items: center" @click="toRewardList(rewardInfo.deliveryId)">
            <div style="display: flex;">
              <img class="reward-img" :src="item.avatar" v-for="(item,index) in rewardOrderList" :key="index" alt="">
            </div>
            <img v-if="rewardInfo.rewardOrderList.length>0" src="../assets/images/reward-arrow.png" alt="" style="display: block;width: .14rem; height: .24rem;">
          </div>
        </div>
      </div>
    </div>
    <div class="reward_mask" v-if="isShowReward">
      <div class="reward_box">
        <img src="../assets/images/reward-close.png" alt="" class="reward-close" @click="closeMask()">
        <div class="reward-tit">感谢您的一份心意</div>
        <div class="amount-box">
          <span style="font-family: PingFangSC-Medium;font-size: .42rem;color: #2F2F2F;margin-right: .2rem;">￥</span>
          <input type="number" placeholder="请输入1-50元的金额" v-model="amount" :class="[isActive ? 'active' : 'noActive']" style="width: 2.5rem;outline: none;" @input="changeAmount(amount)">
        </div>
        <div class="reward-submit" @click="submitReward(1)">确定打赏</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'

  export default {
    name: "Reward",
    data() {
      return {
        rewardInfo: {},
        rewardOrderList: [],
        isShowReward: false,
        amount: '',
        orderId: '',
        isActive: false,
      }
    },
    created(){
      this.orderId = window.localStorage.getItem('orderId');
      this.getRewardInfo();
    },
    methods: {
      getRewardInfo(){
        let _this = this;
        actions.getWeixinRewardInfo(_this, {orderId: _this.orderId}, function (data) {
          _this.rewardInfo = data;
          _this.rewardOrderList = data.rewardOrderList.slice(0,3);
        }, function (data) {
          _this.$messagebox.alert(data.data.message, '')
        })
      },
      toRewardList(id){
        window.localStorage.setItem('deliveryId', id);
        this.$router.push({path:'/rewardList'})
      },
      openReward(item){
        let _this = this;
        _this.amount = '';
        if(item.type == 1){
          _this.isShowReward = true
        } else {
          _this.submitReward(2,item.amount)
        }
      },
      // 打赏
      submitReward(number,val){
        let _this = this;
        let realAmount = number == 1 ? _this.amount : val;
        let params = {
          orderType: 2,
          rewardOrderId: _this.orderId,
          rewardAmount: realAmount
        };
        _this.$indicator.open();//loading
        actions.postOrderCreate(_this, params, function (newdata) {
          _this.$indicator.close()
          if (newdata.status === 0) {
            window.localStorage.setItem('orderCode', newdata.orderId);
            _this.$router.push({name: 'Payment',params:{reward:true}})
          }
        }, function (newdata) {
          _this.$indicator.close()
          _this.$messagebox.alert(newdata.data.message, '')
        })
      },
      closeMask(){
        this.isShowReward = false;
        window.scrollTo(3000,7000);
      },
      changeAmount(val){
        if(val){
          this.isActive = true
        } else {
          this.isActive = false
        }
      }
    }

  }
</script>

<style scoped>
.container{
  background: #fff;
  /*min-height: 100vh;*/
}
.info{
  display: flex;
  justify-content: space-between;
  padding: .3rem;
}
.name{
  width: 5.2rem;
  font-size: .64rem;
  color: #2F2F2F;
  font-weight: 700;
}
.tag{
  font-size: .24rem;
  color: #797979;
  margin-top: .08rem;
}
.headImg{
  width: 1.80rem;
  height: 1.80rem;
  border-radius: 50%;
}
.contact{
  padding: .15rem .3rem .5rem .3rem;
  /*display: flex;*/
  /*align-items: center;*/
}
.message,.tel{
  font-size: .24rem;
  color: #2F2F2F;
}
.reward-line{
  height: .19rem;
  border-left: 1px solid #979797;
  margin: 0 .22rem;
}
.reward{
  background: #fff;
  padding: .3rem;
}
.tit{
  font-size: .36rem;
  color: #2F2F2F;
  font-weight: 700;
}
.des{
  font-size: .22rem;
  color: #707070;
  margin-top: .12rem;
}
.items-box{
  display: flex;
  justify-content: space-around;
  margin-top: .3rem;
}
.avater{
  width: .8rem;
  height: .8rem;
  margin: .28rem auto 0;
}
.reward-items{
  background: #F8F8F8;
  border-radius: .1rem;
  width: 1.65rem;
  height: 2.5rem;
  text-align: center;
}
.reward-price{
  font-size: .32rem;
  color: #2F2F2F;
  font-weight: 700;
  margin-bottom: .07rem;
  margin-top: .2rem;
  height: .44rem;
  line-height: .44rem;
}
.reward-btn{
  display: block;
  background: #FFDF00;
  border-radius: .22rem;
  width: 1.2rem;
  height: .4rem;
  line-height: .4rem;
  text-align: center;
  font-size: .22rem;
  color: #2F2F2F;
  margin: 0 auto;
}
.reward-items:nth-last-child(1) .reward-price{
  font-size: .26rem;
}
.reward-bottom{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: .4rem;
}
.reward-number{
  font-size: .26rem;
  color: #797979;
}
.reward-img{
  width: .46rem;
  height: .46rem;
  border-radius: 50%;
  margin-right: .13rem;
  display: block;
}
.reward_mask{
  background: rgba(0,0,0,0.3);
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9;
}
.reward_box{
  width: 6.9rem;
  height: 5.23rem;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -3.45rem;
  margin-top: -2.62rem;
  border-radius: .26rem;
}
.reward-close{
  width: .21rem;
  height: .21rem;
  margin: .42rem .4rem .26rem 6.29rem;
}
.reward-tit{
  font-family: PingFangSC-Medium;
  font-size: .42rem;
  color: #2F2F2F;
  text-align: center;
  margin-bottom: .9rem;
}
.amount-box{
  display: flex;
  width: 3.05rem;
  margin: 0 auto .79rem;
  border-bottom: 1px solid #979797;;
  padding-bottom: .2rem;
}
.reward-submit{
  width: 4.42rem;
  height: .9rem;
  line-height: .9rem;
  background: #FFDF00;
  border-radius: .5rem;
  text-align: center;
  font-size: .28rem;
  color: #2F2F2F;
  font-weight: 700;
  margin: 0 auto;
}
::-webkit-input-placeholder {
  color: #E5E5E5;
  /*line-height: normal;*/
}
.active{
  font-size: .42rem;
}
.noActive{
  font-size: .26rem;
}
.receive-reward{
  display: flex;
  align-items: center;
  background: #F8F8F8;
  border-radius: .1rem;
  height: 2.05rem;
  margin-top: .42rem;
}
</style>



// WEBPACK FOOTER //
// Reward.vue?2957faaa